window.monacoReady = function () {
    require('./trueMain');
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/main.js
 ** module id = 403
 ** module chunks = 0
 **/